<!--
	Universal Table

	<TableUni
		:title="'Название таблицы'"
		:columns="columns"
		:rows="rows"
		:click="tableRowClick"
		:pageItemsCount="2"
		:sortEnable="true"
		:filtersColumnsEnable="true"
		:wrapHeaders="false"
	>
		<template v-slot:h0="{ col }">
			*** {{ col.value }} ***
		</template>
		<template v-slot:0="{ col }">
			[ {{ col.value }} ]
		</template>
	</TableUni>

	slots are number from 0
	@colId - slots for header's columns for column with id "colId"
	colId - slots for row's columns with id "colId"
	empty - slot for nothing found


	<template v-slot:0="{ data }">
		*** {{ data.column.name }} ***
	</template>
	<template v-slot:label="{ data }">
		*** {{ data.column.name }} ***
	</template>
	<template v-slot:@label="{ data }">
		*** {{ data.column.name }} ***
	</template>

	<template v-slot:[variable]="{ data }">
		*** {{ data.column.name }} ***
	</template>

	if some or all slots are not specified will be used values of columns

  Default templates - if no specified slot, this will be used:
  for headers
	<template v-slot:@col="{ data }"></template>
	for values
	<template v-slot:col="{ data }"></template>

	columns:
	{
		id: {
			show:	default "true", optional
					true	- show
					false	- hide

			filter:	default "", optional
					false	- disable filtering
					""		- no active filtering
					string	- value for filtering
					object {
					  value: "" - filter's value
					  mode: id from modes,
					  modes: {
					    modeId1: {
					      name: "", - mode name
					      icon: "" = mode icon id
					    },
					    modeId2: ...
					  }
					}

			sort:	default "", optional
					false	- disable sorting
					""		- no active sorting
					"asc"	- ascending sort
					"dsc"	- descending sort

			move:	default "true",optional
					true	- can be reoredered
					false	- can not be reoredered

			width:	column's width, optional

			name:	column's name, mandatory,
			title: column's title, if not specified, name will be used instead,

			marked: true/false or class name

			implicit: true for column, which doesn't appear in columns menu
		}
	}

	rows:
	[
		{
			id:	row id,

			marked: true/false or class name,

			columns: {
				idColumn: {
					value: "value of the column with id "idColumn",
					...
				}
			}
		}
	]
-->
<template>
	<div class="tableUni">
		<slot :name="'header'">
			<header class="header" v-if="columnsOrderAndSelectionEnable || title">
				<div class="title" v-if="title">{{ title }}</div>
        <slot :name="'headerMisc'"></slot>
				<div class="controls">
          <button
            v-if="reload"
            @click="reload( { columns: columns_, page: page_ } )"
            :title="$t( 'Refresh' )"
          >
            <Icon
              symbol="reload"
              size="2em"
            />
            {{ $t( 'Refresh' ) }}
          </button>
          <button
            v-if="XLSexport"
            @click="XLSexport( { columns: columns_, page: page_ } )"
            :title="$t( 'ExportXLS' )"
          >
            <Icon
              symbol="XLSexport"
              size="2em"
            />
            {{ $t( 'ExportXLS' ) }}
          </button>
          <button
            v-if="XLSimport"
            @click="XLSimport( { columns: columns_, page: page_ } )"
            :title="$t( 'ImportXLS' )"
          >
            <Icon
              symbol="XLSimport"
              size="2em"
            />
            {{ $t( 'ImportXLS' ) }}
          </button>
					<button
						v-if="columnsOrderAndSelectionEnable"
						@click="cosShow( true )"
						:title="$t( 'Columns' )"
					>
						<Icon
							symbol="columns"
							size="2em"
						/>
						{{ $t( 'Columns' ) }}
					</button>
					<button
						@click="fixedHeaderMode ^= 1"
						:title="$t( fixedHeaderMode ? 'fixedHeaderModeOn' : 'fixedHeaderModeOff' )"
					>
						<Icon
							:symbol="fixedHeaderMode ? 'pinned' : 'pin'"
							size="2em"
						/>
            &#160;
					</button>
				</div>
			</header>
		</slot>
    <div class="scroller">
      <table
        class="table"
        cellspacing="0"
        cellpadding="0"
        border="0"

        :style="tableStyle"
        :class="fixedHeaderMode ? 'fixedHeader' : ''"
      >
        <caption></caption>
        <thead>
          <tr class="row">
            <th
              scope="col"

              v-for="( col, colId ) in columns_"
              :title="col.title || col.name"
              :key="colId"
              :style="{ ... col.width && { width: col.width } }"
              class="cell"
              :class="{ nowrapHeaders: !wrapHeaders, sortable: sortEnable && col.sort !== false, [colClass( col )]: true }"
              v-if="col.show !== false"
              @click="headerColumnPassClick( $event )"
            >
              <div class="label">
                <div
                  class="text"
                  @click="headerColumnClick( col, colId )"
                  :tabindex="sortEnable && col.sort !== false ? 1 : -1"
                >
                 <slot :name="isSlotExists( '@' + ( col.alias ? col.alias : colId ) ) ? '@' + ( col.alias ? col.alias : colId ) : '@col'" v-bind:data="{ column: col, columnId: colId, columns: columns_, rows: rows_ }">{{ col.name }}</slot>
                </div>
                  <div class="buttons" v-if="( sortEnable && col.sort !== false ) || ( filtersColumnsEnable && col.filter !== false )">
                    <button
                      class="sort"
                      :class="col.sort ? col.sort : 'none'"
                      v-if="sortEnable && col.sort !== false"
                      @click="headerColumnClick( col, colId )"
                    >
                      <Icon
                        symbol="sorting"
                        class="icon"
                        size="1em"
                      />
                    </button>
                    <button
                      class="filter"
                      v-if="filtersColumnsEnable && col.filter !== false && !filtersColumnsIsShow( col, colId )"
                      :title="$t( 'ColumnFilter' )"
                      @click.stop="filtersColumnsOn( col, colId )"
                    >
                      <Icon
                        symbol="filter"
                        size="1em"
                      />
                    </button>
                  </div>
                <div v-if="filtersColumnsEnable && col.filter !== false" v-show="filtersColumnsIsShow( col, colId )" class="filterField">
    <!--  						<input type="text" :ref="'filtersInput'" @blur="filtersInputBlur" :value="filts[ i ]" v-debounce.trim="( v ) => { $set( filts, i, v ); }" /> -->
    <!--	  					<input type="text" :ref="'filtersInput'" @blur="filtersInputBlur" :value="filts[ i ]" @input="log( $event.target.value ); $set( filts, i, $event.target.value );" /> -->
                  <input
                    type="text"
                    :placeholder="col.name"
                    :ref="'filtersColumnsInput_' + colId"

                    :disabled2="col.filter && col.filter.mode && ( col.filter.mode == 'exists' || col.filter.mode == 'notexists' )"

                    v-debounce.3000.trim
                    @input="filtersColumnsValue( col, colId, $event.target.value )"
                    @debouncedInput="filtersColumnsApply( col, colId, $event )"
                    @keydown="filtersColumnsOnKeydown( col, colId, $event )"
                    @blur="filtersColumnsResize( col, colId, false ); filtersColumnsInputBlur( col, colId, $event )"
                    @focus="filtersColumnsResize( col, colId, true)"
                  />
    <!--          <div class="error" v-if="errors_ && errors_[ 'filtersColumns_' + colId ]" v-html="errors_[ 'filtersColumns_' + colId ]"></div> -->
                  <Tooltip
                    type="error"
                    class="error"
                    orientation="bottom"
                    anglePosition="start"
                    @close="$delete( errors_, 'filtersColumns_' + colId )"
                  >
                    <div v-if="errors_ && errors_[ 'filtersColumns_' + colId ]" v-html="errors_[ 'filtersColumns_' + colId ]"></div>
                  </Tooltip>

                  <div
                    class="mode"
                    v-if="col.filter && col.filter.modes"
                    :title="$t( 'ColumnFilterMode' )"
                    tabindex="1000"
                  >
                    <Icon
                      v-if="col.filter.mode"

                      class="cur"
                      :symbol="col.filter.modes[ col.filter.mode ].icon"
                      :title="col.filter.modes[ col.filter.mode ].name"
                      size="1em"

                      @click.native.stop="filtersColumnsModesShow = colId"
                    />
                    <Tooltip
                      type="block"
                      class="modes"
                      orientation="bottom"
                      anglePosition="start"
                      :show="filtersColumnsModesShow == colId"
                      :closeIcon="false"
                      v-closable="{ handler: 'filtersColumnsModesClose' }"
                      v-esc="filtersColumnsModesClose"
                    >
                      <Icon
                        class="item"

                        v-for="( m, mid ) in col.filter.modes"
                        :key="mid"

                        :symbol="m.icon"
                        :title="m.name"

                        size="1em"

                        @click.native="filtersColumnsModeSet( col, colId, m, mid )"
                      />
                    </Tooltip>
                  </div>
                  <button
                    @click="filtersColumnsClear( col, colId )"
                    :title="$t( 'ColumnFilterReset' )"
                    class="clear"
                  >
                    <Icon
                      symbol="clear"
                      size="1em"
                    />
                  </button>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
        <template v-if="rows_ && rows_.length">
        <tr
          v-for="( row, i ) in rows_"
          :key="i"

          class="row"
          :class="rowClass( row )"
          @click="rowClick_( row, i, false, $event )"
          @dblclick="rowClick_( row, i, true, $event )"
        >
          <td
            v-for="( col, colId ) in columns_"
            :key="i + '_' + colId"
            v-if="col.show !== false"
            class="cell"
            :class="{ nowrap: !wrap, [colClass( col, row )]: true }"
            :title="colTitle( col, row )"
            @click="rowColClick_( row, i, col, colId, false, $event )"
            @dblclick="rowColClick_( row, i, col, colId, true, $event )"
          >
            <slot :name="isSlotExists( col.alias ? col.alias : colId ) ? ( col.alias ? col.alias : colId ) : 'col'" v-bind:data="{ row, rowIndex: i, column: col, columnId: colId, value: colId in row.columns ? row.columns[ colId ] : '', valueAsText: valueGetAsText( row.columns[ colId ] ), columns: columns_, rows: rows_ }">{{ colId in row.columns ? valueGetAsText( row.columns[ colId ] ) : "" }}</slot>
          </td>
        </tr>
        </template>
        <template v-else>
        <tr class="row empty">
          <td :colspan="columnsShowedNum" class="cell">
            <slot :name="'empty'">{{ $t( 'DataNotFound' ) }}</slot>
          </td>
        </tr>
        </template>
        </tbody>
      </table>
    </div>
    <PaginationUni
			:pages="pages"
			:page="page_"
      :recount="itemsRecount"
			@page="page_ = $event"
      @recount="$emit( 'recount', $event )"
			v-if="pages > 1"
      class="pagination"
		/>

    <Modal
      :show="cosShowState"
      :title="$t( 'ColumnsShowAndSort' )"
      :acceptButtonText="$t( 'Apply' )"
      :cancelButtonText="$t( 'Cancel' )"
      @close="cosShow( false )"
      @accept="cosOk()"
      @cancel="cosShow( false )"
    >
      <div v-drop="cos" class="list">
        <Checkbox
          class="listItem colsCheckAll"
          @input="colsCheckAll( $event )"
        />


        <template v-for="( col, colId, index ) in cos" >
          <template v-if="col.implicit !== true">
            <Checkbox
              :key="index"
              v-if="col.move === false"
              v-model="col.show"
              :label="col.name"
              class="listItem"
            />
            <Checkbox
              :key="index"
              v-else
              v-drag="colId"
              :checked="col.show !== false"
              v-model="col.show"
              :label="col.name"
              class="listItemDraggable"
            />
          </template>
        </template>
      </div>
    </Modal>

    <Modal
        :show="msgShow"
        :title="msgTitle"
        cancelButtonText=""
        @close="msgShow = false"
        @accept="msgShow = false"
    >
      <span v-html="msg" />
    </Modal>
	</div>
</template>

<script>
	import PaginationUni from "@/components/PaginationUni";
	import Modal from "@/components/Modal";
	import Checkbox from "@/components/Checkbox";
  import Icon from "@/components/Icon";
  import Tooltip from "@/components/Tooltip";
	import utils from "@/utils";

	export default {
		name:  "TableUni",
		components: {
			PaginationUni,
			Modal,
			Checkbox,
			Icon,
      Tooltip
		},
    i18n: {
      messages: {
        ru: {
          Columns:            "Столбцы",
          ColumnsShowAndSort: "Выбор и сортировка столбцов таблицы",
          ColumnFilter:       "Фильтрация по столбцу",
          ColumnFilterReset:  "Сбросить фильтр",
          ColumnFilterMode:   "Режим фильтра",

          NoColumnsToShow:    "Выберите хотя-бы один столбец для показа.",

          fixedHeaderModeOn:  "Заголовок таблицы фиксирован, нажмите для не фиксации",
          fixedHeaderModeOff:  "Заголовок таблицы не фиксирован, нажмите для фиксации",
        },

        en: {
          Columns:            "Columns",
          ColumnsShowAndSort: "Select and sort table columns",
          ColumnFilter:       "Filter by column",
          ColumnFilterReset:  "Clean filter",
          ColumnFilterMode:   "Filter mode",

          NoColumnsToShow:    "Please select at least one column to show.",

          fixedHeaderModeOn:  "Table header is fixed, click to unfix it",
          fixedHeaderModeOff:  "Table header is unfixed, click to fix it",
        },

        kz: {
          Columns:            "Бағандар",
          ColumnsShowAndSort: "Кесте бағандарын таңдау және сұрыптау",
          ColumnFilter:       "Баған бойынша сүзу",
          ColumnFilterReset:  "Сүзгіден бас тарту",
          ColumnFilterMode:   "Сүзгі режимі",
          NoColumnsToShow:    "Көрсету үшін кемінде бір бағанды таңдаңыз.",

          fixedHeaderModeOn:  "Кесте тақырыбы бекітілді, оны жою үшін басыңыз",
          fixedHeaderModeOff:  "Кесте тақырыбы түзетілмеген, оны түзету үшін басыңыз",
        }
      }
    },
    props: {
			/**
			 * title of a table
			 */
			title: {
				type: String,
				default: ""
			},
			/**
			 * columns data
			 */
			columns: {
				type: Object
			},
			/**
			 * rows data
			 */
			rows: {
				type: Array
			},
			/**
			 * page number >= 1
			 */
			page: {
				type: Number,
				default: 1
			},
			/**
			 * rows limit per page, "0" means unlimited
			 */
			itemsPerPage: {
				type: Number,
				default: 0
			},
			/**
			 * total number of pages
			 */
			pages: {
				type: Number,
				default: 0
			},
      /**
       * show button for pages count/items request
       */
      itemsRecount: {
			  type: String,
        default: undefined
      },
			/**
			 * handler, will be called on click on the row: function( row, index ) { ... }, row - object of the clicked row
			 * if no handler is specified, event "rowClick" will be produced with event data = { row: ..., rowIndex: ..., isDoubleClick: true/false, event: $event }
			 */
			rowClick: {
				type: Function,
				default: null
			},
			/**
			 * handler, will be called on click on the row's column: function( row, index, col, colId ) { ... }
			 * row		- object of the clicked row
			 * index	- index of the row
			 * col		- object of the clicked column
			 * colId	- column id
			 * if no handler is specified, event "rowColClick" will be produced with event data = { row: ..., rowIndex: ..., column: ..., columnId: ..., isDoubleClick: true/false, event: $event }
			 */
			rowColClick: {
				type: Function,
				default: null
			},
			/**
			 * handler, will be called on each row to check row class: function( row, columns, rows ) { ... }
			 * returns class name or true/false (will be replaced to "marked"/"")
			 * if no handler is specified, "marked" property in the row object will be used
			 */
			rowGetClass: {
				type: Function,
				default: null
			},
			/**
			 * handler, will be called on each column to check column class: function( col, columns, rows, row ) { ... }
       * row can be undefined for headers
			 * returns class name or true/false (will be replaced to "marked"/"")
			 * if no handler is specified, "marked" property in the row object will be used
			 */
			colGetClass: {
				type: Function,
				default: null
			},
			/**
			 * handler, will be called on each column to get title for a column: function( col, columns, rows, row ) { ... }
       * row can be undefined for headers
			 * returns title for column title if present, otherwise undefined
			 */
			colGetTitle: {
				type: Function,
				default: null
			},
			/**
			 * "true" for wrapping columns headers, "false" for cutting long headers by "..."
			 */
			wrapHeaders: {
				type: Boolean,
				default: false
			},
			/**
			 * "true" to wrap columns values, "false" to cut long values by "..."
			 */
			wrap: {
				type: Boolean,
				default: false
			},
			/**
			 * "true" to enable sorting by clicking by the column header
			 */
			sortEnable: {
				type: Boolean,
				default: false,
			},
			/**
			 * true to enable columns filtering
			 */
			filtersColumnsEnable: {
				type: Boolean,
				default: false,
			},
			/**
			 * true to enable columns filtering
			 */
			columnsOrderAndSelectionEnable: {
				type: Boolean,
				default: false,
			},
      /**
       * true to enable reload icon
       */
      reload: {
        type: Function|null,
        default: null,
      },
      /**
       * true to enable export to Excel icon
       */
      XLSexport: {
        type: Function|null,
        default: null,
      },
      /**
       * true to enable import from Excel icon
       */
      XLSimport: {
        type: Function|null,
        default: null,
      },
			/**
			 * "true" to prepare data in the parent component will be emitted update message with object like:
			 * {
			 *		page: page,
			 *		filters: array of filters,
			 *		sort: sorting column,
			 *		sortIsAsc: sorting direction
			 * }
			 *
			 * "false" to use only rows data
			 */
			externalData: {
				type: Boolean,
				default: false
			},
      /**
       */
			show: {
				type: Boolean,
				default: false
			},
      /**
       * function to validate user inputs
       *
       * ( type, colId, v ) => return null or error
       *
       * type:
       * "filtersColumns" - validation of the column's filter
       *
       * colId - column id
       *
       * v - value
       *
       * returns null if no errors, errors text otherwise
       */
      validation: {
			  type: Function,
        default: () => null
      }
		},
		data() {
			return {
				columnsOrderAndSelectionShow: false,

				page_:	this.page ? this.page : 1,

				columns_:	null,

        errors_: {},

				filtersColumnsOnFilter: null,
        filtersColumnsModesShow: null,

				cos: null,
				cosShowState: false,

				show_: this.show,

        msg: null,
        msgTitle: null,
        msgShow: false,

        fixedHeaderMode: +localStorage.getItem( "fixedHeaderMode" ) == "1"
      };
		},
		mounted() {
			this.columnsWatch();
		},
		methods: {
			/*
				dynamic watcher on "columns_"

				It needs because when the "columns_" was changed and generated an "update" event,
				the parent component provides new "columns" data as an answer on the "update" event,
				and the watcher of the "columns" needs to clone it to the "columns_",
				but this action calls the watcher on the "columns_"' again.

				To avoid the duplication of the "update" event before cloning the watcher of the "columns_" will be disabled,
				and will be enabled after cloning will be completed.
			*/
			columnsWatch() {
				if ( !this.$options.columnsWatcher ) {
  			  if ( !this.$options.columnsWatcherHandler ) {
  			    this.$options.columnsWatcherHandler = () => {
							if ( this.externalData ) {
								this.$emit(
									"update",
									{
										cause:		"columns",
										columns:	this.columns_,
										page:		this.page_
									}
								);
              }
						};
          }

					this.$options.columnsWatcher = this.$watch( "columns_", this.$options.columnsWatcherHandler, { deep: true } );
				}
			},
			columnsUnwatch() {
				  if ( this.$options.columnsWatcher ) this.$options.columnsWatcher();
				  this.$options.columnsWatcher = null;
			},
			valueGetAsText( value ) {
				if ( value ) {
					if ( Array.isArray( value ) ) {
						return value.reduce(
							( a, vi ) => {
								let v = vi ? vi : null;

								if ( v ) {
									if ( v.name ) v = v.name;
									if ( v.value ) v = v.value;
								}

								return v ? ( a ? a + ", " : "" ) + v : "";
							},
							""
						);
					}
					else if ( typeof( value ) === "object" && "value" in value ) return value.value;

					return value;
				}

				return "";
			},
			cosShow( state ) {
				if ( state ) {
					this.cos = utils.cloneDeep( this.columns_ );
					this.cosShowState = true;
				}
				else {
					setTimeout( () => { this.cos = null }, 1000 );
					this.cosShowState = false;
				}
			},
      cosOk() {
			  let visible = 0;
			  for ( const id in this.cos ) {
			    if ( this.cos.hasOwnProperty( id ) ) {
			      const col = this.cos[ id ];
			      if ( !col.implicit && col.show !== false ) visible++;
          }
        }

			  if ( !visible ) {
			    this.msgTitle = this.$t( 'Error' );
			    this.msg = this.$t( 'NoColumnsToShow' );
          this.msgShow = true;
          return;
        }

			  this.columns_ = this.cos;
			  this.cosShow( false );
      },
      filtersColumnsIsShow( col, colId ) {
        if ( this.filtersColumnsEnable ) {
//          if ( ( utils.objIs( col.filter ) ? col.filter.value : col.filter ) || this.filtersColumnsOnFilter === colId ) return true;
//if ( utils.objIs( col.filter ) ) console.log( colId, col );
//          if ( ( utils.objIs( col.filter ) ? col.filter.value || ( col.filter.mode && col.filter.modes[ col.filter.mode ].valueDisable ) : col.filter ) || this.filtersColumnsOnFilter === colId ) return true;
          if ( ( utils.objIs( col.filter ) ? col.filter.value : col.filter ) || this.filtersColumnsOnFilter === colId ) return true;

//          const el = this.filtersColumnsGetInput( colId );
//          if ( el && el.value.trim() ) return true;
        }

        return false;
      },
      filtersColumnsGetInput( colId ) {
        let el = this.$refs[ "filtersColumnsInput_" + colId ];
        if ( el && el.length ) el = el[0];
        return el;
      },
      filtersColumnsInputBlur( col, colId, event ) {
			  //return focus to input if the cause of losing focus is click to any element inside the filter and don't close the filter
        const relatedTarget = event && ( event.relatedTarget || event.explicitOriginalTarget );
			  if ( relatedTarget ) {
				  const el = this.filtersColumnsGetInput( colId );
			    if ( el.parentNode && el.parentNode.contains( relatedTarget ) ) {
			      event.stopImmediatePropagation();
			      setTimeout( () => { el.focus(); }, 10 );

			      return;
          }
        }

        let t = this.filtersColumnsGetInput( colId )
        if ( t ) {
          t = t.value.trim();
          if ( t ) this.filtersColumnsApply( col, colId, t );
        }

        this.filtersColumnsOnFilter = null;

        this.$nextTick( () => { this.$delete( this.errors_, "filtersColumns_" + colId ); } );
      },
      filtersColumnsOnKeydown( col, colId, e ) {
			  if ( e.key == "Escape" ) {
			    this.filtersColumnsClear( col, colId );
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
        if ( e.key == "Enter" ) {
          const el = this.filtersColumnsGetInput( colId );
          this.filtersColumnsApply( col, colId, el ? el.value.trim() : "" );
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
      },
			filtersColumnsOn( col, colId ) {
				this.filtersColumnsOnFilter = colId;
				this.$nextTick(
					() => {
					  const el = this.filtersColumnsGetInput( colId );
					  if ( el ) el.focus();
					}
				);
			},
      filtersColumnsApply( col, colId, v ) {
        //if ( col.filter !== v ) this.$set( col, "filter", v );

       const fo = utils.objIs( col.filter );
        const fv = fo ? col.filter.value : col.filter;
        if ( fv !== v ) {
          const en = "filtersColumns_" + colId;
          const err = this.validation( "filtersColumns", colId, v );
          if ( err === null ) {
            this.$delete( this.errors_, en );

            //if filter is object, set value to specified value and if value is empty - set mode to "equal"
            if ( fo ) {
              this.$set( col.filter, "value", v );
              if ( !v ) this.$set( col.filter, "mode", "equal" ); //if value is empty - remove mode from filter
            }
            else this.$set( col, "filter", v );
            //this.filtersColumnsValue( col, colId, v );
          }
          else {
            this.$set( this.errors_, en,  err );
            this.$nextTick( () => {
              const el = this.filtersColumnsGetInput( colId );
              if ( el ) el.value = v;
            } );
          }
        }
      },
      filtersColumnsValue( col, colId, v ) {
			  const fo = utils.objIs( col.filter );

			  //get value
			  if ( v === undefined ) {
			    return fo ? col.filter.value : col.filter;
        }
			  //set value - in current moment it's unnecessary because input value stores in input field, and will be apply on blur/change/timeout
        /*
			  else {
			    this.columnsUnwatch();

			    if ( fo ) this.$set( col.filter, "value", v );
			    else this.$set( col, "filter", v );

			    this.columnsWatch();
        }
        */
      },
			filtersColumnsClear( col, colId ) {
		    this.filtersColumnsOnFilter = null;
        this.$delete( this.errors_, "filtersColumns_" + colId );

        this.filtersColumnsApply( col, colId, "" );

        //reset input value
        const t = this.$refs && this.$refs[ 'filtersColumnsInput_' + colId ];
        if ( t ) t[0].value = "";
			},
      filtersColumnsModesClose() {
			  this.filtersColumnsModesShow = null;
      },
      filtersColumnsModeSet( col, colId, mode, modeId ) {
			  const inputDOM = this.filtersColumnsGetInput( colId );
			  const modePrevEmpty = col.filter.mode == "exists" || col.filter.mode == "notexists"; //previous mode
			  const modeEmpty = modeId == "exists" || modeId == "notexists"; //new mode

		    //if filter is empty - stop to send update event
		    if ( !col.filter.value && !this.columns[ colId ].filter.value ) this.columnsUnwatch();

		    this.$set( col.filter, "mode", modeId );
		    this.columnsWatch();

		    //if previous mode is exists or notexists and next mode is not - remove fake space from the input field
		    if ( modePrevEmpty && !modeEmpty ) {
          inputDOM.value = "";
	        inputDOM.disabled = "";
          this.filtersColumnsApply( col, colId, "" );
        }

		    if ( inputDOM ) {
  		    //if current mode is exists or notexists - set fake one space to the input field
		      if ( modeEmpty ) {
		        inputDOM.value = " ";
		        inputDOM.disabled = "disabled";
          }

		      if ( inputDOM.value ) this.filtersColumnsApply( col, colId, inputDOM.value );

  		    //focus on input field for any modes except exists/notexists modes, blur for exists/notexists modes
		      this.$nextTick(
            () => {
              if ( modeEmpty ) {
  	            const e = document.createEvent( "HTMLEvents" );
	              e.initEvent( "blur", false, true );
	              inputDOM.dispatchEvent( e );
              }
              else inputDOM.focus();
		        }
		      );
        }

		    this.filtersColumnsModesShow = null;
      },
      async filtersColumnsResize( col, colId, resized ) {
			  let el = this.filtersColumnsGetInput( colId );
			  if ( el ) {
			    el = el.parentNode;
			    if ( el ) {
    			  if ( !this.$options.fontSize ) this.$options.fontSize = parseFloat( getComputedStyle( el ).fontSize );

            el.classList.remove( "exceed", "resized" );

            if ( resized ) {
              el.classList.add( "resized" );
//            el.scrollIntoView( { behavior: 'smooth', block: 'nearest', inline: 'center' } );

              if ( !el.classList.contains( "tested" ) ) {
                el.addEventListener(
                  "transitionend",
                  () => {
                   const rect = el.getBoundingClientRect();
                   if ( rect.right > ( window.innerWidth || document.documentElement.clientWidth ) ) {
                     el.classList.add( "exceed_", "exceed" );
                   }
                  }
                );

                const rect = el.getBoundingClientRect();
                //20 (from class "resizes" * font size + borders/paddings
                if ( rect.left + 24 * this.$options.fontSize > ( window.innerWidth || document.documentElement.clientWidth ) ) el.classList.add( "tested", "exceed_" );
              }

              el.classList.add( "resized" );
              if ( el.classList.contains( "exceed_" ) ) el.classList.add( "exceed" );
            }
          }
        }
      },
			rowClick_( row, rowIndex, isDoubleClick, e ) {
				if ( this.rowClick ) this.rowClick( row, rowIndex, isDoubleClick, e );
				else this.$emit( "rowClick", { row, rowIndex, isDoubleClick, e } );
			},
			rowColClick_( row, rowIndex, col, colId, isDoubleClick, e ) {
				if ( this.rowColClick ) this.rowColClick( row, rowIndex, col, colId, isDoubleClick, e );
				else this.$emit( "rowColClick", { row, rowIndex, col, colId, isDoubleClick, e } );
			},
			headerColumnClick: ( () => {
				let tid = null;

				return function( col, colId ) {
					if ( !tid ) {
						tid = setTimeout(
							() => {
								//single click
								tid = null;
								if ( this.sortEnable && col.sort !== false ) {
									for ( let cid in this.columns_ ) {
										if ( this.columns_.hasOwnProperty( cid ) ) {
											const c = this.columns_[ cid ];
											if ( c.sort !== false ) {
												this.$set(
													c,
													"sort",
													cid === colId ? ( c.sort === "" ? "asc" : ( c.sort === "asc" ? "dsc" : "" ) ) : ""
												);
											}
										}
									}
								}
							},
							200
						);
					}
					else {
						//double click
						if ( col.filter !== false ) {
							clearTimeout( tid );
							tid = null;

							if ( this.filtersColumnsEnable ) this.filtersColumnsOn( col, colId );
						}
					}
				}
			} )(),
			rowClass( row ) {
			  let t = "";
			  if ( "marked" in row ) t = row.marked;
			  if ( this.rowGetClass ) t = this.rowGetClass( row, this.columns_, this.rows_ );
			  if ( typeof( t ) != "string" ) t = t ? "marked" : "";

			  return t;
			},
      colClass( col, row ) {
			  let t = "";
			  if ( "marked" in col ) t = col.marked;
			  if ( this.colGetClass ) t = this.colGetClass( col, this.columns_, this.rows_, row );
			  if ( typeof( t ) != "string" ) t = t ? "marked" : "";

			  return t;
      },
      colTitle( col, row ) {
			  if ( this.colGetTitle ) return this.colGetTitle( col, this.columns_, this.rows_, row );
      },

		  isSlotExists( name ) {
			  const slots = this.$scopedSlots;
		    return slots[ name ];// && slots[ name ].reduce( ( hasContent, node ) => ( hasContent || node.tag || ( node.text && node.text.trim() ) ), false );
      },

      colsCheckAll( c ) {
			  for ( const cid in this.cos ) {
			    if ( this.cos.hasOwnProperty( cid ) ) {
			      const col = this.cos[ cid ];
			      if ( col.implicit !== true ) col.show = c;
          }
        }
      },

      headerColumnPassClick( e ) {
			  if ( e && e.target ) {
          const el = e.target.querySelector( ".label > .text" );
		      if ( el ) el.dispatchEvent( new Event( "click", { bubbles: false } ) );
        }
      },

      fixedHeader( tableEl, heightWithUnits ) {
  		  const tfh = e => {
          const el = e.currentTarget;
          const sT = el.scrollTop;
          el.querySelectorAll( "thead th" ).forEach( th => th.style.transform = `translateY(${sT}px)` )
        };

  		  tableEl.style.display = "block";
  		  tableEl.style.overflow = "auto";
  		  tableEl.style.height = heightWithUnits || "300px";

  		  tableEl.querySelectorAll( "thead th" ).forEach(
          th => {
            th.style.position = "relative";
            th.style.zIndex = 5;
          }
  		  );

        tableEl.addEventListener( "scroll", tfh );
      }
		},
		computed: {
			columnsShowedNum() {
				let amount = 0;
				for ( let i in this.columns_ ) if ( this.columns_.hasOwnProperty( i ) && this.columns_[ i ].show !== false ) amount++;

				return amount;
			},
			rows_() {
			  //if data is external
				if ( this.externalData ) return this.rows;

				//if data is internal filtering ignores filteringMode and always uses contains mode
				let sortId = null, sortIsAsc = true;
				let filters = {};
				utils.objEach(
					this.columns_,
					( i, p ) => {
						if ( i.sort ) {
							sortId = p;
							sortIsAsc = i.sort === "asc";
						}

						const filterV = utils.objIs( i.filter ) ? i.filter.value : i.filter;
						if ( filterV ) {
							filters[ p ] = filterV.toString().toLowerCase();
						}
					}
				);

				let rows = this.rows;

				if ( !utils.objIsEmpty( filters ) ) {
					rows = this.rows.filter(
						i => {
							for ( let f in filters ) {
								if ( filters.hasOwnProperty( f ) ) {
									if ( i.columns[ f ].value.toString().toLowerCase().indexOf( filters[ f ] ) < 0 ) return false;
								}
							}

							return true;
						}
					);
				}
				rows = utils.cloneDeep( rows );

				if ( sortId ) {
					const r = sortIsAsc ? 1 : -1;

					rows.sort(
						( a, b ) => {
							const av = a.columns[ sortId ].value, bv = b.columns[ sortId ].value;

							if ( av < bv ) return -r;
							if ( av > bv ) return r;

							return 0;
						}
					);
				}

				return rows;
			},

      tableStyle() {
        return {
          minWidth: ( this.columnsShowedNum * 5 ) + "em"
        }
      }
		},
		watch: {
			columns: {
			  handler( val ) {
  				this.columnsUnwatch();
	  			this.columns_ = utils.cloneDeep( val );

	  			this.$nextTick(
              () => {
                //fill filters inputs by its values, if available
                //the value of the input is not reactive, because it will be stored to reactive only on blur/debounce/enter event
                if ( this.$refs ) {
                  for ( const cid in this.columns_ ) {
                    if ( this.columns_.hasOwnProperty( cid ) ){
                      const i = this.filtersColumnsGetInput( cid );
                      if ( i ) i.value = this.filtersColumnsValue( this.columns_[ cid ], cid );
                    }
                  }
                }
              }
          );

		  		this.columnsWatch();
			  },
        immediate: true
      },

			page( val ) {
				this.page_ = val;
			},
/*
			columns_: {
				deep: true,
				handler() {
					console.log( "columns update detected" );

					this.$emit(
						"update",
						{
							cause:		"columns",
							columns:	this.columns_,
							page:		this.page_
						}
					);
				}
			},
*/
			page_() {
				this.$emit(
					"update",
					{
						cause:		"page",
						columns:	this.columns_,
						page:		this.page_
					}
				);
			},

		  fixedHeaderMode() {
        localStorage.setItem( "fixedHeaderMode", "" + this.fixedHeaderMode );
      }
		}
	};
</script>

<style scoped>
	.tableUni {
		display: flex;
		flex-direction: column;
		height: 100%;

    --headerColor: #FFFFFF;
    --headerBgColor: #40B8ED;

    --cellMarkedBgColor: #FFF9E9;

    --cellHoverBgColor: #EBF1F8;

    --cellHeaderColor: #808080;
    --cellHeaderBgColor: #F2F6FB;
    --cellHeadersBorderColor: #C4C4C4;

    --controlActiveColor: #4D4D4D;
    --controlActiveColorFilter: #36D69B;

    --filterFieldBorderColor: #C4C4C4;

    --cellBorderColor: #C4C4C4;
  }

  .tableUni	.listItem.colsCheckAll {
    margin-bottom: 1em;
  }

  .tableUni	.listItem:last-child,
  .tableUni	.listItemDraggable:last-child {
    margin-bottom: 0;
  }

  .tableUni	.listItemDraggable {
    display: block;
    cursor: grab;
  }

	.tableUni	.header {
    background-color: var(--headerBgColor);
    color: var(--headerColor);
/*    padding: 0.2em;*/
    display: flex;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;
    padding: 1.8em 0.8em 1.4em 0.8em;
  }

	.tableUni	.header .title {
    font-family: Ubuntu, Verdana;
    font-weight: bold;
    white-space: nowrap;
    margin-right: 1em;
    font-size: 1.3em;
  }

  .tableUni .header .controls {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-size: 0.8em;
  }

  .tableUni .header .controls > * {
    margin-right: 2em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .tableUni .header .controls > *:hover {
    color: #FFFFFF !important;
    opacity: 0.8;
  }

  .tableUni .header .controls > * > svg {
    fill: #FFFFFF !important;
    margin-right: 0.5em;
  }

  .tableUni .header .controls * {
    color: var(--headerColor);
  }

  .tableUni .table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
  }

  .tableUni .table {
    border: solid var(--cellBorderColor);
    border-width: 0 1px 1px 1px;
  }

  .tableUni .table .empty {
      pointer-events: none;
  }
  .tableUni .table .empty .cell {
      font-weight: bold;
      text-align: center;
      text-transform: uppercase;
      letter-spacing: 0.2em;
  }

  .tableUni .table .row.marked td.cell {
    background-color: var(--cellMarkedBgColor);
  }

  .tableUni .table .row:hover td.cell {
    background-color: var(--cellHoverBgColor);
  }

  .tableUni .table .cell {
    padding: 1em;
    border: solid var(--cellBorderColor);
    border-width: 0 1px 1px 0;
    transition: all .25s ease;
    text-align: left;
    /*word-break: break-all;*/
    overflow-wrap: anywhere;
    color: #212121;
  }

  .tableUni .table .cell:last-child {
    border-right: none;
  }
  .tableUni .table tbody .row:last-child .cell {
    border-bottom: none;
  }

  .tableUni .table th.cell {
    font-size: 1em;
    padding: .5em .5em .5em .5em;
    color: var(--cellHeaderColor);
    font-weight: normal;
    border-color: var(--cellHeadersBorderColor);
    background-color: var(--cellHeaderBgColor);
    border-bottom-width: 2px;
    overflow-wrap: anywhere;
    vertical-align: top;
  }

  .tableUni .table th.cell.nowrapHeaders {
    vertical-align: top;
  }

  .tableUni .table .cell.nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: unset;
    /*word-break: unset;*/
  }

  .tableUni .table th.cell .label {
    display: flex;
    position: relative;
    align-items: flex-start;
    overflow: inherit;
    text-overflow: inherit;
    word-break: inherit;
    overflow-wrap: inherit;
  }

  .tableUni .table th.cell.nowrapHeaders .label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: center;
    overflow-wrap: unset;
    word-break: unset;
  }
/*
  .tableUni .table th.cell .label .text {
    overflow: inherit;
    text-overflow: inherit;
    word-break: break-all;
    overflow-wrap: unset;
  }

  .tableUni .table th.cell .label .buttons {
    float: right;
    white-space: nowrap;
    position: relative;
    z-index: 1;
  }
  .tableUni .table th.cell .label .buttons > * {
    margin: 0 0 0 0.2em;
  }
*/

  .tableUni .table th.cell .label .text {
    overflow: inherit;
    text-overflow: inherit;
    overflow-wrap: unset;
    flex-grow: 1;
    flex-shrink: 1;
    line-height: 1em;
  }

  .tableUni .table th.cell .label .buttons {
    white-space: nowrap;
    flex-grow: 0;
    flex-shrink: 0;
  }
  .tableUni .table th.cell .label .buttons > * {
    margin: 0 0 0 0.2em;
  }

  .tableUni .table th.cell.sortable .label .text {
    cursor: pointer;
    transition: all .25s ease;
  }

  .tableUni .table th.cell.sortable .label .text:hover,
  .tableUni .table th.cell.sortable .label .text:focus {
    color: var(--controlActiveColor);
    text-shadow: 0 0 .1px var(--controlActiveColor);
  }

  .tableUni .table th.cell .label .sort {
    visibility: hidden;
  }
  .tableUni .table th.cell.sortable .label:hover .sort.none {
    visibility: visible;
  }

  .tableUni .table th.cell .label .sort.asc,
  .tableUni .table th.cell .label .sort.dsc {
    visibility: visible;
  }
  .tableUni .table th.cell .label .sort .icon {
    transform: scaleY(-1);
    opacity: 0.2;
  }
  .tableUni .table th.cell .label .sort.asc .icon,
  .tableUni .table th.cell .label .sort.dsc .icon {
 /*   fill: var(--controlActiveColor); */
    opacity: 1;
  }
  .tableUni .table th.cell .label .sort.dsc .icon {
    transform: scaleY(1);
  }

  .tableUni .table th.cell .label .filter {
    border: none;
    background: transparent;
    cursor: pointer;
    vertical-align: top;
    padding: 0;
    font-size: 0.75em;
  }
  .tableUni .table th.cell .label .icon,
  .tableUni .table th.cell .label .icon {
    vertical-align: top;
    height: 1em;
    width: 1em;
  }
  .tableUni .table th.cell .label .filter .icon {
    margin-top: 0.2em;
  }

  .tableUni .table th.cell .label .filterField {
    position: absolute;
    padding: 0;
    box-sizing: border-box;
    left: 0;

    height: 1em;
    bottom: 0.2em;

    right: 1.2em;
    margin: 0;
    display: flex;
    align-items: center;
    border-radius: 0.2em;
    background-color: var(--cellHeaderBgColor);
  }

   .tableUni .table th.cell.nowrapHeaders .label {
     height: 1.7em;
   }
   .tableUni .table th.cell.nowrapHeaders .label .filterField {
     height: unset;
     top: 0;
     bottom: 0;
   }

  .tableUni .table th.cell .label .filterField button {
    position: absolute;
    right: 0.3em;
    top: 50%;
    transform: translate( 0, -50% );
    padding: 0;
    margin: 0;
    font-size: 0.8em;
    line-height: 0;
  }

/*
  .tableUni th.cell .label .filterField .error {
    word-break: normal;
    background: #FFB5B5;
    color: #000000;
    position: absolute;
    top: 2em;
    left: 0;
    padding: 0.2em;
    border-radius: 0.2em;
    box-shadow: 0 0 3px 1px rgba( 0, 0, 0, 0.5 );
    font-size: 0.8em;
    max-width: 15em;
  }
*/
  .tableUni .table th.cell .label .filterField .error {
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
  }

  .tableUni .table th.cell .label .filterField input {
    display: block;
    font-family: inherit;
    width: 100%;
    font-size: inherit;
    padding: 0.1em 2.2em 0.1em 0.2em;
    box-sizing: border-box;
    border: 1px solid var(--filterFieldBorderColor);
    border-radius: 0.2em;
    outline: none !important;
    background-color: #FFFFFF;
    /* box-shadow: inset 1px 1px 1px 0 rgba( 0, 0, 0, 0.7 ); */
  }

  .tableUni button {
    border: none;
    padding: 0;
    margin: 0;
    transition: all .25s ease;
    background: none;
    cursor: pointer;
    font-size: inherit;
  }

  .tableUni button:hover,
  .tableUni button:hover * {
    fill: var(--controlActiveColor) !important;
    stroke: var(--controlActiveColor) !important;
    color: var(--controlActiveColor) !important;
  }
  .tableUni button.filter:hover svg {
    fill: var(--controlActiveColorFilter) !important;
  }

  .tableUni th.cell .label .filterField button {
    margin-left: 1em;
  }
  .tableUni th.cell .label .filterField::placeholder {
    opacity: .3;
  }

  .tableUni .pagination {
    text-align: left;
    padding: 1em 0 0 0;
  }
/*
.tableUni__table > tbody > tr > th > .filtersColumnsField {
  display: block;
  padding-right: 2em;
  position: relative;
}
.tableUni__table > tbody > tr > th > .filtersColumnsField > input {
  display: inline-block;
  width: 100%;
  outline: none;
  border: 0;
  background: #FFFFFF;
  padding: 0 0.2em;
}
.tableUni__table > tbody > tr > th > .filtersColumnsField > .clear {
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.tableUni__table > tbody > tr > th > .filtersColumnsField > .clear:hover {
  color: #0090FF;
}

.columnsSelection {
  float: left;
}
*/

.tableUni .list {
  display: flex;
  flex-direction: column;
  max-width: 80vw;
  overflow-x: hidden;
  text-overflow: ellipsis;
  color: #212121;
}
.tableUni .list > * {
  margin-bottom: 0.2em;
}
.tableUni .list > *:last-child {
  margin-bottom: 0;
}
.dragging {
  cursor: -webkit-grabbing;
  cursor:    -moz-grabbing;
  cursor:         grabbing;
  background-color: #E0E0E0;
}

.dropping {
  background-color: #0090FF;
}
.tableUni > .scroller {
  display: inline-block;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

.tableUni .table th.cell .label .filterField .mode {
  position: absolute;
  right: 1.3em;
  top: 0.1em;
}
.tableUni .table th.cell .label .filterField .mode > .cur {
  font-size: 0.8em;
  color: #000000;
}
.tableUni .table th.cell .label .filterField .mode > .cur:hover,
.tableUni .table th.cell .label .filterField .mode > .modes .item:hover {
  fill: var(--controlActiveColor) !important;
  stroke: var(--controlActiveColor) !important;
  color: var(--controlActiveColor) !important;
}

.tableUni .table th.cell .label .filterField .mode > .modes {
  position: relative;
  top: -1em;
  left: -0.6em;
}
.tableUni .table th.cell .label .filterField .mode > .modes::v-deep > .content {
  min-width: unset;
  z-index: 1;
}
.tableUni .table th.cell .label .filterField .mode > .modes .item {
  display: block;
  margin: 0.7em 0 0 0;
  width: 1.2em;
  height: 1.2em;
  opacity: 1 !important;
}
.tableUni .table th.cell .label .filterField .mode > .modes .item:first-child {
  margin-top: 0;
}
.tableUni .table th.cell .label .filterField .mode > .modes .item:hover {
  opacity: 0.5;
}

.tableUni .table th.cell .label .filterField {
  transition: all .1s linear;
}
.tableUni .table th.cell .label .filterField.resized {
  z-index: 1;
  right: -20em;
  position: absolute;
  box-shadow: 2px 4px 3px rgba( 0, 0, 0, 0.7 );
}
.tableUni .table th.cell .label .filterField.exceed {
  right: 0;
  left: -20em;
}
/*
.tableUni > .scroller {
  display: inline-block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  overflow-y: hidden;
}

.tableUni > .scroller > .table {
  overflow-x: visible;
}
*/

/* fixed header */
.tableUni .table.fixedHeader {
  overflow: auto;
  height: 100px;
}
.tableUni .table.fixedHeader thead {
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 5000;
  left: 0;
  right: 0;
  box-shadow: 3px 0 3px rgba( 0, 0, 0, 0.5 );
}
.tableUni .table.fixedHeader thead th {
  box-shadow: 0 0 0 1px var(--cellBorderColor);
}
</style>
